import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { 
    NavController, IonIcon, IonLabel
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvColor, MarvColorGreen, MarvColorOrange, MarvColorRed } from '@marv/types';
import { MarvSubItemComponent, MarvProgressBarComponent, MarvButtonComponent } from '@marv/components';
import { PermanentOperationItem, PermanentAgentItem } from '@app/components';

@Component({
    selector: 'app-permanent-agent-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        IonIcon, IonLabel, TranslatePipe, 
        forwardRef(() => MarvSubItemComponent), forwardRef(() => MarvProgressBarComponent), forwardRef(() => MarvButtonComponent)
    ]
})
export class PermanentAgentItemComponent  implements OnInit {

    @Input({alias : 'permanentOperation', required : true}) permanentOperation: PermanentOperationItem;
    @Input({alias : 'permanentAgent', required : true}) permanentAgent: PermanentAgentItem;

    rateSelected: '7D'|'15D' = '15D';

    constructor(        
        private navController: NavController
    ) { }

    ngOnInit() {}

    selectRate(rate: '7D'|'15D'){
        this.rateSelected = rate;
    }

    getColorPlanningRateDays(planningRate: number): MarvColor{
        let color: MarvColor = MarvColorRed;
        if(planningRate > 80){
            color = MarvColorGreen;
        }
        else if(planningRate > 30){
            color = MarvColorOrange;
        }
        return color;
    }

    seePlanning(){
        let params = {
            operationId: this.permanentOperation.id,
            agentId: this.permanentAgent.id
        };        
        this.navController.navigateRoot('permanent-planning', {queryParams: params});
    }
}
